import { DefaultFooter } from '@ant-design/pro-components';
import { useModel } from '@umijs/max';
import React from 'react';

const Footer: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const appName =
    initialState?.appProfile?.name ||
    initialState?.settings?.title ||
    'Skeleton Admin';
  const currentYear = new Date().getFullYear();

  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={`${currentYear} ${appName}`}
    />
  );
};

export default Footer;
